{
  "name": "Sandstorm",
  "ambInd": 3,
  "skyDome": true,
  "skyDomeCol0": "#7bd7ff",
  "skyDomeCol1": "#f7d4b4",
  "skyDomeCol2": "#dce8ed",
  "ambient": 10654352,
  "light": 16777215,
  "sky": 14477549,
  "fog": 12294553,
  "fogD": 633.4396002067896,
  "modes": [0],
  "camPos": [-124, 62, -269],
  "spawns": [[0, 13, -3, 0, 0, 0], [-77, 33, -347, 0, 1, 0], [278, 33, 122, 0, 2, 0], [-105, 48, 86, 0, 1, 0], [241, 33, -322, 0, 1, 0], [-42, 48, 48, 0, 0, 0], [-39, 33, -210, 0, 3, 0]],
  "ambO": 0.7,
  "ambS": 5,
  "shadLength": 387,
  "shadWidth": 425,
  "objects": [{
    "p": [-5, 12, 0],
    "s": [94, 1, 114],
    "t": 1
  }, {
    "p": [-67, 12, 0],
    "s": [30, 1, 44],
    "t": 1
  }, {
    "p": [-178, 32, 0],
    "s": [122, 1, 150],
    "t": 1
  }, {
    "p": [-163, 14, 157],
    "s": [154, 34, 56],
    "t": 1
  }, {
    "p": [-28, 9, 104],
    "s": [312, 39, 50],
    "t": 1
  }, {
    "p": [1, 47, -26],
    "s": [104, 1, 210],
    "t": 1
  }, {
    "p": [194, -4, 56],
    "s": [216, 37, 221],
    "t": 1
  }, {
    "p": [-175, 19, -137],
    "s": [53, 25, 64],
    "t": 1
  }, {
    "p": [64, 13, -4],
    "s": [44, 20, 36],
    "i": 9,
    "t": 1
  }, {
    "p": [-208, 33, 101],
    "s": [36, 15, 56],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-174, 33, -89],
    "s": [48, 11, 32],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-175, 33, -185],
    "s": [53, 11, 32],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [80, 33, -106],
    "s": [54, 15, 49],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [110, 33, 54],
    "s": [36, 15, 50],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-138, 26, 76],
    "s": [104, 29, 6],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-187, 26, 104],
    "s": [6, 29, 50],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [159, 32, 103],
    "s": [38, 1, 55],
    "t": 1
  }, {
    "p": [-50, 16, -225],
    "s": [6, 22, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -246],
    "s": [6, 36, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 31, -207],
    "s": [6, 19, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 38, -216],
    "s": [6, 4, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [220, 33, 125],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-103, 32, -128],
    "s": [96, 2, 111],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-103, 109, -129],
    "s": [100, 3, 117],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [61, 87, -245],
    "s": [87, 4, 77],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [20, 87, -167],
    "s": [169, 4, 79],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [61, 30, -242],
    "s": [82, 4, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [20, 30, -166],
    "s": [164, 4, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 2
  }, {
    "p": [20, 32, -166],
    "s": [162, 55, 71],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-33, 51, -202],
    "s": [15, 1, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-40, 34, -202],
    "s": [1, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-26, 34, -202],
    "s": [1, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-33, 34, -201],
    "s": [13, 17, 2],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-147, 112, -120],
    "s": [35, 3, 15],
    "c": 5263440,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 33, -194],
    "s": [36, 1, 21],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-159, 40, -308],
    "s": [87, 1, 57],
    "t": 1
  }, {
    "p": [-187, 33, -268],
    "s": [31, 8, 23],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-141, 40, -270],
    "s": [51, 1, 19],
    "t": 1
  }, {
    "p": [-169, 17, -270],
    "s": [5, 29, 19],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-141, 17, -258],
    "s": [61, 29, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 17, -299],
    "s": [5, 29, 77],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-103, 17, -129],
    "s": [94, 92, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-97, 33, -349],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-197, 44, -155],
    "s": [1, 19, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-229, 32, -162],
    "s": [56, 45, 111],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-229, 77, -162],
    "s": [61, 3, 115],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-248, 32, -309],
    "s": [94, 94, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-248, 126, -309],
    "s": [102, 3, 117],
    "c": 5723991,
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 32, -237],
    "s": [56, 33, 111],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 65, -237],
    "s": [62, 3, 111],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 31, -236],
    "s": [58, 3, 35],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-229, 31, -162],
    "s": [58, 3, 112],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-340, 32, -199],
    "s": [91, 73, 116],
    "c": "#ffd5b1"
  }, {
    "p": [-197, 44, -163],
    "s": [1, 19, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-63, 32, -411],
    "s": [81, 85, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-170, 97, -392],
    "s": [140, 4, 120],
    "c": 4408131,
    "t": 11,
    "bo": 1
  }, {
    "p": [-110, 82, -335],
    "s": [4, 4, 8],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 32, -392],
    "s": [133, 65, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-63, 117, -411],
    "s": [87, 4, 119],
    "c": 5066061,
    "t": 11,
    "bo": 1
  }, {
    "p": [-63, 154, -411],
    "s": [58, 3, 56],
    "c": 4868682,
    "t": 11
  }, {
    "p": [22, 61, -381],
    "s": [91, 32, 88],
    "c": "#ffd5b1"
  }, {
    "p": [-203, 134, -483],
    "s": [97, 5, 94],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-103, 84, -129],
    "s": [95, 2, 113],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-103, 59, -129],
    "s": [96, 2, 113],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-63, 123, -411],
    "s": [52, 32, 49],
    "c": "#ffd5b1"
  }, {
    "p": [61, 32, -241],
    "s": [80, 55, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-63, 89, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-63, 59, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-250, 82, -309],
    "s": [100, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [61, 59, -242],
    "s": [82, 2, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [20, 59, -166],
    "s": [164, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-63, 32, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-151, 82, -335],
    "s": [4, 4, 9],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-189, 82, -335],
    "s": [4, 4, 10],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 32, -194],
    "s": [34, 27, 18],
    "c": "#ffd5b1"
  }, {
    "p": [15, 45, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [15, 33, -220],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-204, 32, -485],
    "s": [91, 102, 87],
    "c": "#ffd5b1"
  }, {
    "p": [22, 90, -381],
    "s": [98, 4, 93],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [22, 59, -381],
    "s": [92, 2, 89],
    "l": 1,
    "c": "#525252",
    "t": 11
  }, {
    "p": [22, 32, -381],
    "s": [93, 2, 89],
    "l": 1,
    "c": "#525252",
    "t": 11
  }, {
    "p": [253, 32, -160],
    "s": [64, 53, 72],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [193, 95, -293],
    "s": [70, 3, 117],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [193, 54, -292],
    "s": [69, 2, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [193, 32, -285],
    "s": [70, 2, 101],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [154, 59, -273],
    "s": [18, 2, 44],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [147, 33, -293],
    "s": [2, 29, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [147, 33, -253],
    "s": [2, 29, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [158, 33, -244],
    "s": [1, 38, 4],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [129, 32, -403],
    "s": [124, 73, 93],
    "c": "#ffd5b1"
  }, {
    "p": [129, 105, -404],
    "s": [132, 4, 115],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [168, 33, -404],
    "s": [44, 1, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [129, 33, -355],
    "s": [37, 36, 6],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [236, 32, -367],
    "s": [90, 32, 61],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [236, 64, -367],
    "s": [97, 5, 68],
    "c": 5395026,
    "t": 2,
    "bo": 1
  }, {
    "p": [236, 29, -367],
    "s": [92, 5, 63],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [74, 33, -341],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [57, 33, -288],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [261, 33, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [273, 33, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-213, 59, -246],
    "s": [10, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-213, 59, -225],
    "s": [10, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-59, 33, -336],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-59, 33, -348],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-50, 16, -360],
    "s": [6, 40, 15],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -270],
    "s": [6, 40, 41],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -240],
    "s": [6, 29, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 38, -234],
    "s": [6, 2, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 50, -204],
    "s": [6, 6, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -286],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -270],
    "s": [6, 2, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -254],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -200],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -319],
    "s": [6, 2, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -334],
    "s": [6, 3, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [15, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [3, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-9, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-158, 41, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-146, 41, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-124, 41, -269],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [169, 32, -352],
    "s": [44, 73, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [90, 32, -352],
    "s": [46, 73, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [130, 69, -352],
    "s": [34, 36, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [86, 33, -341],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [319, 32, -317],
    "s": [79, 58, 183],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [319, 90, -317],
    "s": [87, 4, 189],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [319, 60, -281],
    "s": [80, 2, 112],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 32, -281],
    "s": [81, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [281, 70, -240],
    "s": [4, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [281, 70, -270],
    "s": [4, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [282, 69, -270],
    "s": [7, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [282, 69, -240],
    "s": [7, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [126, 43, -355],
    "s": [3, 5, 8],
    "c": "#464646",
    "t": 5
  }, {
    "p": [327, 32, -470],
    "s": [142, 99, 87],
    "c": "#ffd5b1"
  }, {
    "p": [328, 130, -470],
    "s": [152, 4, 96],
    "c": 4868682,
    "t": 11
  }, {
    "p": [191, 32, -555],
    "s": [109, 76, 87],
    "c": "#ffd5b1"
  }, {
    "p": [191, 105, -557],
    "s": [113, 5, 100],
    "c": 5395026,
    "t": 11
  }, {
    "p": [325, 32, -186],
    "s": [80, 77, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [326, 109, -185],
    "s": [88, 3, 86],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [326, 86, -186],
    "s": [83, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [326, 60, -186],
    "s": [83, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [168, 62, -160],
    "s": [20, 2, 44],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [176, 64, -180],
    "s": [2, 7, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [176, 71, -160],
    "s": [3, 1, 44],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [171, 71, -181],
    "s": [7, 1, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [167, 64, -160],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [167, 81, -160],
    "s": [2, 1, 15],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [167, 64, -167],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [299, 32, -100],
    "s": [52, 63, 93],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [326, 32, -185],
    "s": [84, 2, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [299, 95, -100],
    "s": [57, 3, 97],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [278, 29, -100],
    "s": [12, 5, 95],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [265, 39, -256],
    "s": [3, 1, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [265, 33, -256],
    "s": [1, 6, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [241, 33, -281],
    "s": [1, 6, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [241, 39, -281],
    "s": [3, 1, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [233, 63, -265],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -269],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -277],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -293],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -273],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -281],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -289],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -297],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [-133, 59, -195],
    "s": [36, 2, 19],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-133, 60, -194],
    "s": [34, 1, 19],
    "pe": 1,
    "v": 1,
    "c": 4408131,
    "t": 2
  }, {
    "p": [215, 33, -179],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [215, 33, -167],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [199, 33, -86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [173, 30, -341],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5988172,
    "t": 5
  }, {
    "p": [325, 32, -14],
    "s": [80, 55, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [319, 32, 135],
    "s": [68, 76, 115],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [325, 87, -14],
    "s": [86, 3, 85],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [325, 29, -14],
    "s": [82, 5, 81],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [304, 32, 30],
    "s": [13, 43, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [304, 32, 73],
    "s": [13, 43, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [304, 75, 51],
    "s": [13, 9, 53],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [302, 43, 47],
    "s": [3, 8, 3],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 33, 51],
    "s": [1, 42, 39],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [325, 60, -14],
    "s": [81, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [304, 77, 51],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 62],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 72],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 40],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 30],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [431, 12, -96],
    "s": [92, 102, 160],
    "c": "#ffd5b1"
  }, {
    "p": [431, 113, -96],
    "s": [99, 4, 165],
    "c": 4868682,
    "t": 11
  }, {
    "p": [319, 108, 135],
    "s": [74, 3, 121],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [319, 83, 135],
    "s": [69, 2, 116],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 56, 135],
    "s": [69, 2, 116],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [94, -2, -52],
    "s": [80, 114, 60],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [180, 32, -48],
    "s": [92, 40, 64],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [180, 72, -48],
    "s": [95, 4, 66],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [94, 111, -52],
    "s": [88, 4, 67],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [94, 32, -52],
    "s": [82, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [180, 32, -48],
    "s": [94, 2, 65],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 32, 135],
    "s": [70, 2, 117],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [92, 33, -404],
    "s": [44, 1, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-144, 32, -345],
    "s": [83, 2, 20],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [269, 29, -76],
    "s": [6, 5, 25],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-156, 44, -136],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [280, 33, 0],
    "s": [1, 23, 6],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 8684676,
    "t": 2
  }, {
    "p": [281, 33, 10],
    "s": [1, 18, 6],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 8684676,
    "t": 2
  }, {
    "p": [240, 32, 163],
    "s": [92, 51, 64],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [240, 83, 163],
    "s": [97, 3, 70],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [239, 56, 163],
    "s": [91, 2, 65],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [240, 32, 163],
    "s": [90, 2, 66],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [235, 57, 123],
    "s": [49, 2, 17],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [213, 32, 117],
    "s": [2, 28, 2],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [257, 32, 117],
    "s": [2, 28, 2],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [205, 33, 130],
    "s": [5, 34, 1],
    "i": 3,
    "t": 2,
    "d": 3
  }, {
    "p": [94, 59, -52],
    "s": [81, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [94, 86, -52],
    "s": [81, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [226, 34, -67],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [226, 34, -60],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [226, 51, -67],
    "s": [2, 1, 15],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [226, 34, -74],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-159, 76, -120],
    "s": [2, 38, 2],
    "l": 1,
    "c": 12303291,
    "t": 2
  }, {
    "p": [158, 32, 72],
    "s": [60, 68, 93],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [158, 67, 72],
    "s": [61, 2, 94],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [142, 75, 31],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [142, 74, 31],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [194, 33, 34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [149, 38, 158],
    "s": [70, 60, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [77, 32, 169],
    "s": [74, 69, 80],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [192, 33, 125],
    "s": [6, 1, 15],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [77, 101, 169],
    "s": [81, 4, 87],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [77, 76, 169],
    "s": [74, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [77, 47, 169],
    "s": [74, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [154, 33, 115],
    "s": [47, 1, 5],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [115, 33, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [127, 33, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [79, 61, 14],
    "s": [10, 1, 2],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [182, 79, 32],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [182, 78, 32],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-97, 33, -199],
    "s": [30, 6, 1],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-113, 33, -199],
    "s": [2, 25, 2],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-81, 33, -199],
    "s": [2, 25, 2],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-97, 39, -199],
    "s": [30, 1, 3],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-81, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-113, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-85, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-109, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-105, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-101, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-97, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-89, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-93, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [65, 91, 51],
    "s": [58, 4, 80],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [133, 33, 22],
    "s": [4, 17, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [140, 33, 22],
    "s": [4, 17, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [65, 54, 51],
    "s": [55, 2, 75],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [79, 62, 16],
    "s": [9, 14, 5],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-102, 34, -17],
    "s": [42, 61, 62],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-102, 92, -17],
    "s": [47, 4, 67],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-102, 32, -18],
    "s": [44, 2, 62],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [206, 13, -15],
    "s": [15, 74, 7],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [206, 32, -13],
    "s": [17, 2, 5],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [180, 30, 115],
    "s": [2, 9, 2],
    "l": 1,
    "c": 5988172,
    "t": 5
  }, {
    "p": [-87, 100, 47],
    "s": [67, 4, 72],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-87, 102, 48],
    "s": [45, 10, 55],
    "c": "#ffd5b1"
  }, {
    "p": [-87, 112, 48],
    "s": [51, 4, 61],
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-87, 76, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-87, 52, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-67, 84, 26],
    "s": [9, 14, 7],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-67, 83, 23],
    "s": [10, 1, 2],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [73, 32, 52],
    "s": [40, 2, 78],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [65, 13, 51],
    "s": [54, 79, 74],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [28, 12, -46],
    "s": [169, 2, 54],
    "c": "#6e6e6e",
    "t": 2
  }, {
    "p": [27, 12, 37],
    "s": [167, 2, 52],
    "c": "#6e6e6e",
    "t": 2
  }, {
    "p": [-52, 46, -32],
    "s": [8, 31, 210],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 46, -28],
    "s": [8, 31, 117],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -80],
    "s": [8, 2, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -58],
    "s": [8, 3, 15],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -36],
    "s": [8, 5, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -14],
    "s": [8, 3, 16],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, 8],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 8],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 30],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 74],
    "s": [8, 4, 14],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 52],
    "s": [8, 3, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -14],
    "s": [8, 2, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -36],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -58],
    "s": [8, 3, 16],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -80],
    "s": [8, 4, 10],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -102],
    "s": [8, 3, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -124],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-1, 12, 19],
    "s": [110, 34, 14],
    "c": "#786555",
    "t": 11
  }, {
    "p": [-1, 11, -51],
    "s": [110, 35, 62],
    "c": "#786555",
    "t": 11
  }, {
    "p": [-1, 46, -2],
    "s": [94, 1, 57],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-51, 32, 188],
    "s": [73, 76, 116],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-124, 32, 215],
    "s": [73, 76, 62],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-197, 32, 217],
    "s": [73, 52, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [13, 47, 163],
    "s": [60, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-52, 47, 157],
    "s": [73, 2, 56],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-126, 47, 211],
    "s": [75, 2, 55],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-265, -3, 183],
    "s": [63, 104, 108],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-268, 62, 74],
    "s": [84, 55, 111],
    "c": "#ffd5b1"
  }, {
    "p": [-268, 32, -10],
    "s": [73, 56, 60],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-232, 61, -73],
    "s": [68, 49, 68],
    "c": "#ffd5b1"
  }, {
    "p": [-51, 108, 187],
    "s": [81, 3, 121],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [-128, 108, 214],
    "s": [73, 3, 68],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-70, 32, 127],
    "s": [28, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-70, 47, 125],
    "s": [30, 2, 8],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-51, 77, 157],
    "s": [75, 2, 56],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-126, 77, 211],
    "s": [75, 2, 55],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-117, 50, 154],
    "s": [25, 1, 25],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-14, 24, -245],
    "s": [29, 13, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-117, 24, 168],
    "s": [31, 28, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-103, 24, 154],
    "s": [3, 28, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-131, 24, 154],
    "s": [3, 28, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-196, 47, 180],
    "s": [73, 2, 7],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-242, 47, 154],
    "s": [19, 2, 57],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-242, 73, 154],
    "s": [19, 2, 57],
    "l": 1,
    "h": 190,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-196, 84, 214],
    "s": [80, 3, 81],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [67, 33, -285],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -1.57, 0]
  }, {
    "p": [-265, 101, 178],
    "s": [70, 3, 124],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-228, 32, 49],
    "s": [5, 2, 62],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-234, 32, -9],
    "s": [7, 2, 63],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-214, 32, -71],
    "s": [34, 2, 65],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-265, 117, 74],
    "s": [86, 3, 119],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [431, 40, -96],
    "s": [66, 102, 125],
    "c": "#ffd5b1"
  }, {
    "p": [431, 141, -96],
    "s": [77, 4, 135],
    "c": 4868682,
    "t": 11
  }, {
    "p": [-266, 78, -11],
    "s": [78, 3, 59],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-232, 109, -73],
    "s": [74, 3, 72],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [-239, 62, 74],
    "s": [27, 2, 112],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-268, 88, 74],
    "s": [85, 2, 112],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 60, -73],
    "s": [69, 2, 69],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 84, -73],
    "s": [69, 2, 69],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-227, 48, 171],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-215, 48, 171],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-78, 48, 86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-176, 48, 87],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-125, 33, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-137, 33, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-90, 48, 86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-225, 33, -34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-213, 33, -34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-129, 33, -33],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-179, 48, 174],
    "s": [6, 19, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-189, 48, 174],
    "s": [6, 19, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-228, 120, 42],
    "s": [35, 3, 15],
    "c": 5263440,
    "t": 2,
    "bo": 1
  }, {
    "p": [-217, 69, 42],
    "s": [2, 53, 2],
    "l": 1,
    "c": 12303291,
    "t": 2
  }, {
    "p": [-232, 34, 3],
    "s": [2, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-231, 34, -4],
    "s": [1, 17, 1],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-231, 34, 10],
    "s": [1, 17, 1],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-231, 51, 3],
    "s": [1, 1, 15],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-232, 72, 14],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -11],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, 1],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -24],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -35],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-222, 32, 59],
    "s": [1, 23, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-222, 33, 52],
    "s": [1, 16, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-55, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-55, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [47, 48, 123],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [110, 48, 125],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, 1.57, 0]
  }, {
    "p": [40, 48, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [29, 47, -28],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [29, 47, 4],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [36, 78, 4],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -4],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, 0],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -8],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -12],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -16],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -20],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -24],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -28],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [29, 47, -12],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [29, 54, -12],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [40, 48, -66],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [46, 47, 4],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [46, 47, -28],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, 8],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-38, 78, 8],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 12],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 20],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 16],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 24],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 28],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 32],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 36],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 40],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-30, 47, 40],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, 24],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 54, 24],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, 8],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, 40],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, -59],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-38, 78, -59],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -63],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -67],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -71],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -75],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -79],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -83],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -87],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -91],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-30, 47, -91],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, -59],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, -91],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, -75],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 54, -75],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-44, 47, -17],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-44, 47, -8],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [35, 91, -143],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [32, 48, 43],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [32, 48, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [32, 48, 55],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-40, 46, 77],
    "s": [32, 31, 8],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [26, 46, 77],
    "s": [24, 31, 8],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-46, 77, 77],
    "s": [4, 4, 8],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-30, 77, 77],
    "s": [8, 3, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [20, 77, 77],
    "s": [8, 2, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [36, 77, 77],
    "s": [4, 2, 8],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-42, 48, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [227, 33, -297],
    "s": [3, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [227, 33, -265],
    "s": [3, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [280, 33, -240],
    "s": [4, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-159, 41, -308],
    "s": [83, 50, 55],
    "i": 14,
    "l": 1
  }, {
    "p": [240, 33, 106],
    "s": [87, 50, 45],
    "i": 14,
    "l": 1
  }, {
    "p": [-151, 48, 104],
    "s": [64, 50, 48],
    "i": 14,
    "l": 1
  }, {
    "p": [-1, 48, -23],
    "s": [89, 50, 72],
    "i": 14,
    "l": 1
  }, {
    "p": [-1, 48, -35],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 48, -23],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-195, 41, -309],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-195, 53, -309],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [158, 100, 72],
    "s": [67, 3, 101],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [158, 32, 72],
    "s": [62, 2, 95],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [126, 41, 94],
    "s": [6, 48, 24],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [169, 32, -341],
    "s": [22, 2, 11],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [153, 33, -325],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [188, 32, -222],
    "s": [291, 1, 335],
    "t": 1
  }, {
    "p": [134, 32, -160],
    "s": [66, 76, 72],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [193, 54, -292],
    "s": [68, 43, 114],
    "c": "#ffd5b1"
  }, {
    "p": [273, 63, -240],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -244],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -252],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -248],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -256],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -264],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -260],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -272],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -268],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [280, 33, -272],
    "s": [4, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [134, 108, -160],
    "s": [71, 4, 77],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [246, 29, -160],
    "s": [52, 5, 74],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [278, 29, -174],
    "s": [12, 5, 46],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [252, 60, -160],
    "s": [63, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [284, 60, -160],
    "s": [1, 2, 73],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [253, 85, -160],
    "s": [67, 3, 75],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [135, 29, -160],
    "s": [66, 5, 74],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [135, 59, -160],
    "s": [66, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [101, 59, -126],
    "s": [2, 2, 5],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [101, 59, -129],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [134, 84, -160],
    "s": [67, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [176, 64, -140],
    "s": [2, 7, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [171, 71, -139],
    "s": [7, 1, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [167, 64, -153],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [171, 33, -155],
    "s": [1, 20, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#616161",
    "t": 2
  }, {
    "p": [171, 33, -142],
    "s": [1, 20, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#616161",
    "t": 2
  }, {
    "p": [144, 33, -202],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [144, 45, -202],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [181, 33, -229],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [267, 33, -118],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, 33, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, 45, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-41, 33, -349],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-14, 35, -258],
    "s": [23, 1, 23],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-117, 24, 140],
    "s": [31, 28, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-27, 24, -258],
    "s": [3, 13, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-14, 24, -271],
    "s": [29, 13, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-1, 24, -258],
    "s": [3, 13, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [281, 32, 80],
    "s": [9, 14, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [218, 32, 80],
    "s": [5, 16, 5],
    "c": "#9d8672"
  }, {
    "p": [148, 33, -118],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [233, 63, -285],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [279, 33, 108],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [203, 32, 80],
    "s": [30, 15, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [255, 32, 80],
    "s": [5, 16, 5],
    "c": "#9d8672"
  }, {
    "p": [-166, 48, 85],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 134],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 141],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 148],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-147, 33, 69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-41, 13, 8],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-34, 13, 8],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 48, 180],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 48, 173],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-153, 44, -127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-134, 41, -267],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-198, 41, -299],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-208, 33, -249],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-208, 33, -242],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-30, 33, -350],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [11, 33, -333],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [96, 33, -343],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [154, 33, -282],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [154, 33, -275],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [191, 33, -231],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [280, 33, -201],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [280, 33, -208],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [257, 33, -120],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [189, 33, -84],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, -36],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, -29],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [193, 33, 44],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, 127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [237, 33, 127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 48, 84],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [22, 48, 69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, 57],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, -26],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, -114],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [9, 48, -24],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [395, 7, 103],
    "s": [80, 88, 59],
    "c": "#ffd5b1"
  }, {
    "p": [396, 95, 104],
    "s": [88, 4, 67],
    "c": 4868682,
    "t": 11
  }, {
    "p": [184, 32, 235],
    "s": [102, 76, 49],
    "c": "#ffd5b1"
  }, {
    "p": [184, 108, 235],
    "s": [109, 5, 57],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-89, 33, -137],
    "s": [54, 1, 97],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-121, 32, 14],
    "s": [6, 2, 2],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-68, 32, 47],
    "s": [26, 2, 68],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-102, 62, -17],
    "s": [43, 2, 63],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-123, 34, 0],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-122, 34, -7],
    "s": [4, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-122, 34, 7],
    "s": [4, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-122, 51, 0],
    "s": [4, 1, 15],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-60, 24, -69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-84, 43, -34],
    "s": [7, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-84, 42, -34],
    "s": [8, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-111, 10, -62],
    "s": [12, 23, 43],
    "t": 1
  }, {
    "p": [-93, 24, -62],
    "s": [24, 9, 28],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [241, 33, -297],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [241, 33, -265],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [265, 33, -272],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [265, 33, -240],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-61, 3, -61],
    "s": [40, 21, 26],
    "t": 1
  }, {
    "p": [-69, 13, -35],
    "s": [26, 11, 26],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-85, 32, -318],
    "s": [255, 1, 281],
    "c": "#ffffff",
    "t": 1
  }, {
    "p": [52, 33, -106],
    "s": [2, 14, 50],
    "t": 1
  }, {
    "p": [302, 43, 57],
    "s": [3, 8, 3],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [134, 43, -355],
    "s": [3, 5, 8],
    "c": "#464646",
    "t": 5
  }, {
    "p": [-40, 33, -219],
    "s": [4, 2, 3],
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#9d8672"
  }, {
    "p": [-59, 33, -230],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#9d8672"
  }, {
    "p": [-64, 33, -223],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [400, 123, -68],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [400, 122, -68],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [236, 33, 101],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-144, 41, -301],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-205, 32, -237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d2b559"
  }, {
    "p": [-208, 32, -224],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14],
    "c": "#d2b559"
  }, {
    "p": [-65, 32, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14]
  }, {
    "p": [-78, 32, -198],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-57, 32, -205],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-100, 32, -340],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-67, 32, -351],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.3, 0]
  }, {
    "p": [-87, 32, -352],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-50, 16, -326],
    "s": [6, 40, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -345],
    "s": [6, 34, 15],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-28, 32, -343],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-19, 32, -206],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-22, 35, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.6, 0]
  }, {
    "p": [-9, 35, -265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [-191, 39, -300],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-167, 40, -331],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-136, 41, -332],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-197, 40, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-120, 40, -278],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-134, 40, -273],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.05, -3.14]
  }, {
    "p": [-152, 32, -205],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.36, -3.14]
  }, {
    "p": [23, 32, -286],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [4, 32, -217],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [16, 32, -229],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.16, 0]
  }, {
    "p": [-107, 32, -258],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [-106, 33, -296],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [5, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [12, 32, -326],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.1, 0]
  }, {
    "p": [31, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [48, 32, -291],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [68, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [73, 32, -284],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [156, 32, -316],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [149, 32, -278],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [156, 32, -344],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [103, 32, -282],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.08, 0]
  }, {
    "p": [105, 32, -249],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [-70, 96, 130],
    "s": [30, 4, 23],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-70, 69, 123],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-70, 68, 121],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [39, 32, -283],
    "s": [25, 2, 9],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [39, 14, -282],
    "s": [24, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [39, 79, -278],
    "s": [25, 3, 22],
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [38, 51, -286],
    "s": [15, 1, 7],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [38, 50, -288],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [263, 14, -197],
    "s": [24, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [263, 79, -193],
    "s": [26, 3, 22],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [262, 51, -201],
    "s": [15, 1, 7],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [262, 50, -203],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-146, 87, 185],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-146, 86, 183],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [100, 82, 130],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [100, 81, 128],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-82, 91, -184],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-82, 90, -186],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-133, 37, -188],
    "s": [28, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-133, 52, -190],
    "s": [30, 2, 8],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 101, -185],
    "s": [30, 4, 23],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-133, 74, -192],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-133, 73, -194],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [87, 66, -281],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [87, 65, -282],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [13, 32, 160],
    "s": [55, 110, 60],
    "c": "#ffd5b1"
  }, {
    "p": [13, 37, 128],
    "s": [56, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [13, 98, 126],
    "s": [59, 4, 14],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [27, 74, 124],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [27, 73, 122],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [13, 141, 160],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-2, 73, 122],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-2, 74, 124],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-43, 131, 149],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-43, 111, 149],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [-69, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-17, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-44, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-44, 111, 164],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-69, 111, 163],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-17, 111, 163],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-29, 116, 133],
    "s": [11, 1, 3],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [-29, 112, 131],
    "s": [11, 5, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [-60, 125, 131],
    "s": [8, 8, 1],
    "l": 1,
    "c": "#b2d4b2",
    "t": 2
  }, {
    "p": [-60, 132, 133],
    "s": [8, 1, 3],
    "l": 1,
    "c": "#b2d4b2",
    "t": 2
  }, {
    "p": [-75, 111, 131],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-86, 111, 132],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [13, 113, 126],
    "s": [40, 2, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [31, 113, 123],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-5, 113, 123],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [13, 121, 123],
    "s": [40, 1, 3],
    "c": "#393939",
    "t": 2
  }, {
    "p": [31, 121, 129],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-5, 121, 129],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [20, 116, 131],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [13, 116, 130],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [27, 116, 130],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [20, 133, 130],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [20, 115, 130],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [5, 108, 121],
    "s": [6, 14, 1],
    "l": 1,
    "c": "#dec28f",
    "t": 2
  }, {
    "p": [1, 108, 121],
    "s": [2, 14, 1],
    "l": 1,
    "c": "#a4be8d",
    "t": 2
  }, {
    "p": [1, 122, 123],
    "s": [2, 1, 5],
    "l": 1,
    "c": "#a4be8d",
    "t": 2
  }, {
    "p": [5, 122, 123],
    "s": [6, 1, 5],
    "l": 1,
    "c": "#dec28f",
    "t": 2
  }, {
    "p": [40, 102, 143],
    "s": [8, 50, 14],
    "c": "#ffd5b1"
  }, {
    "p": [-8, 161, 157],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-21, 132, 142],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [76, 103, 141],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [76, 123, 141],
    "s": [1, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [59, 123, 137],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [65, 113, 142],
    "s": [6, 11, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [52, 113, 136],
    "s": [7, 11, 1],
    "l": 1,
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [65, 124, 139],
    "s": [6, 1, 7],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [65, 121, 136],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [52, 124, 139],
    "s": [7, 1, 7],
    "l": 1,
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [52, 122, 142],
    "s": [7, 2, 1],
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [59, 123, 141],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [59, 123, 145],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-212, 119, 247],
    "s": [120, 3, 33],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-212, 80, 257],
    "s": [120, 35, 45],
    "c": "#ffd5b1"
  }, {
    "p": [-212, 115, 257],
    "s": [120, 20, 15],
    "c": "#ffd5b1"
  }, {
    "p": [-212, 136, 256],
    "s": [121, 3, 17],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-132, 52, 254],
    "s": [40, 89, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-118, 143, 254],
    "s": [12, 14, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 158, 254],
    "s": [40, 8, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 141, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-132, 165, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-146, 143, 254],
    "s": [12, 14, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-145, 167, 241],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-145, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-119, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-119, 167, 240],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 157, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-131, 137, 228],
    "s": [4, 4, 15],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-131, 134, 232],
    "s": [3, 2, 13],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-292, 52, 254],
    "s": [40, 91, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 143, 254],
    "s": [40, 23, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 141, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-292, 165, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-305, 167, 241],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-305, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 240],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 157, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [115, 97, -102],
    "s": [2, 2, 69],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [123, 97, -102],
    "s": [2, 2, 66],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [131, 97, -102],
    "s": [2, 2, 65],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 99, -104],
    "s": [11, 1, 12],
    "l": 1,
    "c": "#acb1af",
    "e": "#502323",
    "t": 2
  }, {
    "p": [127, 99, -90],
    "s": [11, 1, 12],
    "l": 1,
    "c": "#868785",
    "e": "#0e110b",
    "t": 2
  }, {
    "p": [132, 81, -90],
    "s": [1, 18, 12],
    "l": 1,
    "c": "#868785",
    "e": "#0e110b",
    "t": 2
  }, {
    "p": [126, 99, -116],
    "s": [11, 1, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [121, 86, -116],
    "s": [1, 13, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [113, 90, -104],
    "s": [1, 9, 12],
    "l": 1,
    "c": "#acb1af",
    "e": "#502323",
    "t": 2
  }, {
    "p": [-111, 68, -64],
    "s": [2, 2, 69],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-103, 68, -64],
    "s": [2, 2, 66],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-108, 70, -64],
    "s": [11, 1, 8],
    "c": "#bb5d5d",
    "t": 2
  }, {
    "p": [-100, 70, -82],
    "s": [11, 1, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [-105, 65, -82],
    "s": [1, 5, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [-113, 61, -64],
    "s": [1, 9, 8],
    "l": 1,
    "c": "#bb5d5d",
    "t": 2
  }, {
    "p": [-268, 33, 74],
    "s": [84, 31, 111],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-119, 26, 154],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#7f6e38"
  }, {
    "p": [-175, 47, 171],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-229, 47, 154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-155, 47, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-159, 47, 84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-179, 47, 97],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [-101, 47, 87],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-88, 47, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-52, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-60, 47, 83],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [31, 47, 85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [36, 47, 119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-19, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-56, 45, -47],
    "s": [2, 2, 54],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 32, -73],
    "s": [68, 28, 67],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-8, 142, 157],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-24, 45, 129],
    "s": [2, 58, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-41, 103, 129],
    "s": [36, 2, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-58, 105, 129],
    "s": [2, 9, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-87, 34, 47],
    "s": [62, 66, 66],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-87, 13, 47],
    "s": [62, 19, 66],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-102, 13, -17],
    "s": [42, 19, 62],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-340, 105, -199],
    "s": [93, 4, 119],
    "c": "#393939",
    "t": 11
  }, {
    "p": [22, 32, -381],
    "s": [91, 27, 88],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-292, 52, 112],
    "s": [40, 89, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 143, 98],
    "s": [40, 14, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 158, 112],
    "s": [40, 8, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 141, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-292, 165, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-305, 167, 99],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-305, 167, 125],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 125],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 98],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 157, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-268, 137, 111],
    "s": [15, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-292, 143, 126],
    "s": [40, 14, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-285, 119, 184],
    "s": [120, 3, 33],
    "l": 1,
    "r": [-1.57, -1.05, -1.57],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-296, 115, 190],
    "s": [15, 20, 120],
    "c": "#ffd5b1"
  }, {
    "p": [-296, 136, 187],
    "s": [121, 3, 17],
    "l": 1,
    "r": [-1.57, -1.05, -1.57],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-295, 80, 187],
    "s": [45, 35, 120],
    "c": "#ffd5b1"
  }, {
    "p": [-226, 45, 122],
    "s": [2, 58, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 103, 124],
    "s": [2, 2, 6],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 105, 126],
    "s": [2, 18, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [164, 34, 142],
    "s": [60, 105, 48],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [164, 139, 142],
    "s": [63, 5, 51],
    "c": "#313131",
    "t": 11
  }, {
    "p": [164, 144, 142],
    "s": [56, 21, 40],
    "c": "#ffd5b1"
  }, {
    "p": [164, 165, 142],
    "s": [30, 35, 30],
    "c": "#ffd5b1"
  }, {
    "p": [164, 200, 142],
    "s": [34, 6, 34],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 206, 142],
    "s": [29, 6, 28],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 212, 142],
    "s": [23, 6, 22],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 218, 142],
    "s": [17, 6, 16],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 224, 142],
    "s": [5, 13, 9],
    "c": "#ffd5b1"
  }, {
    "p": [164, 237, 142],
    "s": [3, 32, 4],
    "c": "#ffd5b1"
  }, {
    "p": [164, 165, 142],
    "s": [58, 3, 42],
    "c": "#313131",
    "t": 11
  }, {
    "p": [164, 165, 157],
    "s": [10, 20, 1],
    "c": "#3c3c3c"
  }, {
    "p": [142, 129, 142],
    "s": [4, 4, 58],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [186, 129, 142],
    "s": [4, 4, 58],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 129, 128],
    "s": [68, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 129, 156],
    "s": [68, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 50, 165],
    "s": [16, 2, 8],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 94, 165],
    "s": [16, 2, 8],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 34, 26],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [154, 34, 25],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [168, 34, 25],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [161, 51, 25],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [161, 33, 25],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [149, 96, 158],
    "s": [71, 4, 81],
    "c": "#525252",
    "t": 11
  }, {
    "p": [-119, 57, 31],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-117, 58, 31],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-119, 57, 62],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-117, 58, 62],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-151, 89, -90],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-149, 90, -90],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-216, 90, 233],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-216, 91, 235],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-177, 90, 233],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-177, 91, 235],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-216, 89, -38],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-216, 90, -40],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-197, 89, -93],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-199, 90, -93],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-225, 32, 15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-203, 32, -35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-128, 32, -23],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-123, 32, 18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-123, 32, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [-149, 32, 61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [-187, 32, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-222, 32, 44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-153, 32, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-140, 33, -72],
    "s": [2, 45, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-132, 89, -72],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-132, 90, -74],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-143, 78, -72],
    "s": [8, 2, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-146, 80, -72],
    "s": [2, 34, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-197, 33, -44],
    "s": [2, 82, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [573, 13, -162],
    "s": [55, 40, 60],
    "c": "#ffd5b1"
  }, {
    "p": [573, 52, -162],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [517, 42, -173],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [517, 22, -173],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [491, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [543, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [516, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [516, 22, -158],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [491, 22, -159],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [543, 22, -159],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [531, 27, -189],
    "s": [11, 1, 3],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [531, 23, -191],
    "s": [11, 5, 1],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [500, 36, -191],
    "s": [8, 8, 1],
    "c": "#a1e1a1",
    "t": 2
  }, {
    "p": [500, 43, -189],
    "s": [8, 1, 3],
    "c": "#a1e1a1",
    "t": 2
  }, {
    "p": [511, 27, -187],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -0.17, 0]
  }, {
    "p": [573, 24, -196],
    "s": [40, 2, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [591, 24, -199],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [555, 24, -199],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [573, 32, -199],
    "s": [40, 1, 3],
    "c": "#393939",
    "t": 2
  }, {
    "p": [591, 32, -193],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [555, 32, -193],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [580, 27, -191],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [573, 27, -192],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [587, 27, -192],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [580, 44, -192],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [580, 26, -192],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [565, 19, -201],
    "s": [6, 14, 1],
    "c": "#e6ab3e",
    "t": 2
  }, {
    "p": [561, 19, -201],
    "s": [2, 14, 1],
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [561, 33, -199],
    "s": [2, 1, 5],
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [565, 33, -199],
    "s": [6, 1, 5],
    "c": "#e6ab3e",
    "t": 2
  }, {
    "p": [552, 72, -165],
    "s": [1, 7, 1],
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [539, 43, -180],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -0.17, 0]
  }, {
    "p": [552, 53, -165],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [306, 88, -169],
    "s": [54, 44, 56],
    "c": "#ffd5b1"
  }, {
    "p": [306, 130, -169],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [250, 108, -180],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [250, 88, -180],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [224, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [276, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [249, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [249, 88, -165],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [224, 88, -166],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [276, 88, -166],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [264, 93, -196],
    "s": [11, 1, 3],
    "c": "#dc7c7c",
    "t": 2
  }, {
    "p": [264, 85, -198],
    "s": [11, 9, 1],
    "c": "#d26262",
    "t": 2
  }, {
    "p": [221, 102, -173],
    "s": [1, 8, 7],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [244, 93, -194],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [285, 149, -172],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [272, 109, -187],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [285, 131, -172],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [223, 109, -173],
    "s": [3, 1, 7],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [136, 84, -198],
    "s": [40, 2, 9],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 84, -201],
    "s": [2, 8, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 84, -201],
    "s": [2, 8, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [136, 92, -201],
    "s": [40, 1, 3],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 92, -195],
    "s": [3, 1, 9],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 92, -195],
    "s": [3, 1, 9],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [124, 79, -203],
    "s": [5, 14, 1],
    "l": 1,
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [124, 93, -201],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [272, 88, -156],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [272, 100, -156],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [136, 86, -197],
    "s": [1, 17, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [150, 86, -197],
    "s": [1, 17, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [143, 103, -197],
    "s": [15, 1, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [143, 86, -196],
    "s": [13, 17, 2],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-232, 80, 145],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-234, 81, 145],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-225, 95, 101],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-227, 96, 101],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [127, 88, 94],
    "s": [8, 3, 26],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#525252",
    "t": 11
  }, {
    "p": [122, 66, 94],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [124, 67, 94],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-13, 11, -257],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.35, 3.14],
    "c": "#846d22"
  }, {
    "p": [111, 78, 28],
    "s": [47, 2, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [111, 78, 36],
    "s": [47, 2, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [119, 80, 32],
    "s": [8, 1, 11],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [119, 71, 27],
    "s": [8, 9, 1],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [99, 71, 37],
    "s": [3, 9, 1],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [99, 80, 32],
    "s": [3, 1, 11],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [99, 75, 27],
    "s": [3, 5, 1],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [119, 77, 37],
    "s": [8, 3, 1],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [-200, 95, -276],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 96, -276],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-200, 95, -312],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 96, -312],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-124, 68, -33],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-122, 69, -33],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [20, 65, -225],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [22, 66, -225],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [158, 70, -318],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [160, 71, -318],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-42, 96, -354],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-42, 97, -356],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-8, 67, -336],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-8, 68, -338],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [90, 78, -346],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [90, 79, -348],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-55, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-112, 45, 81],
    "s": [2, 66, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-225, 103, -128],
    "s": [43, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-225, 80, -128],
    "s": [43, 8, 72],
    "c": "#ffd5b1"
  }, {
    "p": [-206, 88, -162],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-206, 88, -109],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -162],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -109],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -136],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-206, 88, -136],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-201, 124, -104],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 105, -104],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-213, 105, -113],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-205, 80, -169],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-216, 80, -170],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-207, 105, -145],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#6383ed",
    "t": 2
  }, {
    "p": [-203, 95, -145],
    "s": [1, 10, 13],
    "l": 1,
    "c": "#6383ed",
    "t": 2
  }, {
    "p": [-200, 33, -258],
    "s": [2, 83, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-200, 116, -262],
    "s": [2, 18, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-200, 116, -259],
    "s": [2, 2, 4],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 68, -244],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-218, 68, -234],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [270, 34, -76],
    "s": [6, 48, 24],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [271, 81, -76],
    "s": [12, 3, 26],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#525252",
    "t": 11
  }, {
    "p": [266, 59, -76],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [268, 60, -76],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [284, 62, 94],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [286, 63, 94],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [284, 65, 3],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [286, 66, 3],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [189, 75, 97],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [187, 76, 97],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [189, 75, 51],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [187, 76, 51],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [220, 65, -181],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [222, 66, -181],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [193, 34, -292],
    "s": [68, 20, 113],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-161, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-263, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-195, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-228, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 225],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 141],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 179],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-319, 34, -70],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.87, 0]
  }, {
    "p": [-335, 46, 4],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 1.4, -3.14]
  }, {
    "p": [-385, 50, -47],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.23, 0]
  }, {
    "p": [181, 120, -296],
    "s": [43, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [181, 97, -295],
    "s": [43, 8, 72],
    "c": "#ffd5b1"
  }, {
    "p": [200, 105, -323],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -262],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -289],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -317],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [194, 122, -264],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [201, 97, -330],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, 0.52, 0]
  }, {
    "p": [190, 97, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [163, 122, -306],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#3661f0",
    "t": 2
  }, {
    "p": [159, 112, -306],
    "s": [1, 10, 13],
    "l": 1,
    "c": "#3661f0",
    "t": 2
  }, {
    "p": [172, 122, -266],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#66b18e",
    "t": 2
  }, {
    "p": [172, 110, -260],
    "s": [9, 12, 1],
    "l": 1,
    "c": "#66b18e",
    "t": 2
  }, {
    "p": [181, 95, -346],
    "s": [44, 32, 54],
    "c": "#ffd5b1"
  }, {
    "p": [181, 127, -346],
    "s": [46, 2, 56],
    "c": "#525252",
    "t": 11
  }, {
    "p": [201, 105, -289],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [201, 105, -262],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [200, 105, -317],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [197, 98, -253],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [164, 105, -266],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [158, 33, -341],
    "s": [2, 80, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [158, 113, -331],
    "s": [2, 19, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [158, 113, -337],
    "s": [2, 2, 10],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 125, -346],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 144, -346],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 149, -344],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [166, 48, -80],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [166, 47, -81],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [70, 92, -82],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [70, 91, -83],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [268, 62, 131],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [268, 61, 130],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-67, 82, 14],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-67, 81, 13],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-80, 71, -19],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-82, 72, -19],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [135, 90, -39],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [133, 91, -39],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [102, 65, -262],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [100, 66, -262],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [228, 70, -316],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [226, 71, -316],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [151, 64, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [151, 65, -125],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [233, 65, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [233, 66, -125],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [151, 48, -15],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [151, 49, -17],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [211, 67, -234],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [210, 68, -236],
    "s": [6, 1, 16],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-200, 54, -204],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 55, -204],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [68, 91, -21],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [68, 92, -23],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [53, 91, -54],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [55, 92, -54],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [63, 64, -129],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [63, 65, -131],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [16, 64, -129],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [16, 65, -131],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-79, 64, -72],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-79, 65, -74],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-28, 33, -130],
    "s": [2, 61, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 33, 23],
    "s": [2, 43, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 78, 17],
    "s": [2, 15, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 76, 20],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [219, 33, -81],
    "s": [2, 47, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 32, -132],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 72, -135],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 74, -138],
    "s": [2, 16, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-140, 34, -203],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-126, 34, -203],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 51, -203],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 34, -202],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [353, 21, -77],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [360, 29, -127],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-0.01, -1.4, -0.01]
  }, {
    "p": [266, 11, 231],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [226, 0, -434],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [-156, 43, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14]
  }, {
    "p": [-155, 43, -164],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-198, 43, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-160, 43, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-196, 43, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [105, 32, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [132, 32, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.08, -3.14]
  }, {
    "p": [172, 32, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [154, 32, -200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [191, 32, -225],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [199, 32, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [216, 32, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [247, 32, -201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [273, 32, -206],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [280, 32, -221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [264, 32, -237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.95, 0]
  }, {
    "p": [230, 32, -234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.47, -3.14]
  }, {
    "p": [239, 32, -262],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.47, -3.14]
  }, {
    "p": [275, 32, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [240, 32, -301],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [275, 32, -320],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [253, 32, -331],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.62, 0]
  }, {
    "p": [172, 32, -161],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [216, 32, -157],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.77, 0]
  }, {
    "p": [171, 32, -137],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [189, 32, -91],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [182, 32, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [158, 32, -120],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [225, 32, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [216, 32, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.12, -1.5, -3.12]
  }, {
    "p": [250, 32, -119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.59, 0]
  }, {
    "p": [257, 32, -112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.11, 0]
  }, {
    "p": [269, 32, -109],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.24, 0]
  }, {
    "p": [266, 32, -90],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.41, 0]
  }, {
    "p": [230, 32, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [270, 32, -61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [280, 32, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [280, 32, -6],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.11, 0]
  }, {
    "p": [231, 32, -23],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.06, 0]
  }, {
    "p": [218, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.81, 0]
  }, {
    "p": [294, 32, 31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.76, 0]
  }, {
    "p": [294, 32, 72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.76, 0]
  }, {
    "p": [251, 32, 77],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.28, 0]
  }, {
    "p": [199, 32, 43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [191, 32, 25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [192, 32, 74],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [192, 32, 85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [194, 32, 113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [210, 32, 126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.82, -3.14]
  }, {
    "p": [197, 32, 126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.82, -3.14]
  }, {
    "p": [228, 32, 120],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [242, 32, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.75, 0]
  }, {
    "p": [217, 32, 115],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [279, 32, 98],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [282, 32, 86],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.75, 0]
  }, {
    "p": [137, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [144, 32, 21],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [96, 32, 26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.99, -3.14]
  }, {
    "p": [106, 32, -17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.99, -3.14]
  }, {
    "p": [57, 47, 124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [103, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [123, 47, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [94, 47, 87],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-48, 68, 24],
    "s": [2, 2, 30],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-45, 55, -25],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [46, 68, -12],
    "s": [2, 2, 30],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [23, 55, 70],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [21, 55, 70],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [22, 54, 68],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-14, 91, -132],
    "s": [3, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [28, 91, -132],
    "s": [3, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [7, 92, -130],
    "s": [51, 22, 1],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [-42, 48, -124],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [47, 91, -135],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.17, 0]
  }, {
    "p": [-17, 91, -135],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [7, 92, -130],
    "s": [53, 1, 2],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [38, 103, -143],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.17, 0]
  }, {
    "p": [-16, 98, -136],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [-76, 106, -150],
    "s": [34, 20, 40],
    "c": "#ffd5b1"
  }, {
    "p": [-76, 126, -150],
    "s": [36, 3, 42],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-63, 122, -135],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-63, 141, -135],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-63, 146, -133],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 107, 25],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 126, 25],
    "s": [1, 6, 1],
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 131, 27],
    "s": [1, 3, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-30, 94, -130],
    "s": [6, 2, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-32, 96, -130],
    "s": [2, 6, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-250, 98, -18],
    "s": [31, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-236, 88, -37],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-236, 88, 16],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-236, 88, -10],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-264, 88, -10],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-264, 88, 16],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-263, 88, -37],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 100, -30],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-235, 111, -43],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-239, 88, 11],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-166, 121, -351],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-166, 101, -351],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [-192, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-140, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-167, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-167, 101, -336],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-192, 101, -337],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-140, 101, -337],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-136, 115, -344],
    "s": [1, 8, 7],
    "l": 1,
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [-179, 106, -339],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-144, 122, -358],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-138, 122, -344],
    "s": [3, 1, 7],
    "l": 1,
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [-95, 121, -383],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-110, 101, -353],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-222, 101, -362],
    "s": [54, 44, 56],
    "c": "#ffd5b1"
  }, {
    "p": [-222, 143, -362],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-43, 55, -25],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-45, 55, -27],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-43, 55, -27],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [222, 85, 132],
    "s": [3, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [264, 85, 132],
    "s": [3, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [243, 87, 131],
    "s": [51, 22, 1],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [217, 85, 134],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [243, 87, 130],
    "s": [53, 1, 2],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [213, 93, 137],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 1.21, 0]
  }, {
    "p": [325, 57, -4],
    "s": [18, 46, 38],
    "c": "#ffd5b1"
  }, {
    "p": [325, 103, -4],
    "s": [21, 3, 40],
    "c": "#525252",
    "t": 11
  }, {
    "p": [324, 95, 10],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [324, 114, 10],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [324, 119, 12],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-83, 121, -380],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-204, 137, -305],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [-203, 129, -304],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-204, 127, -294],
    "s": [2, 27, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-203, 131, -278],
    "s": [1, 21, 46],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-203, 131, -278],
    "s": [3, 1, 46],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-204, 127, -262],
    "s": [2, 26, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-202, 129, -311],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-214, 129, -259],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-227, 129, -255],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-201, 136, -339],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 155, -339],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 160, -337],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [210, 85, 138],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.34, 0]
  }, {
    "p": [39, 12, -16],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.16, 0]
  }, {
    "p": [-27, 12, 7],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.76, -3.14]
  }, {
    "p": [-61, 12, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.81, -3.14]
  }, {
    "p": [-59, 22, -63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.24, 0]
  }, {
    "p": [-77, 22, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.41, 0]
  }, {
    "p": [-128, 32, -42],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-87, 32, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-118, 24, 153],
    "s": [5, 127, 6],
    "v": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-14, 36, -257],
    "s": [5, 123, 6],
    "v": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [438, 32, 66],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [397, 32, 15],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.53, 0]
  }, {
    "p": [22, 47, 63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [34, 47, 34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-32, 47, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-45, 47, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-29, 47, 42],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.06, 1.56, 3.06]
  }, {
    "p": [-42, 47, -13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.06, 1.56, 3.06]
  }, {
    "p": [-42, 47, -34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [9, 47, -31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-44, 47, -91],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-32, 47, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [42, 47, -56],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [42, 47, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [32, 47, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.23, 3.14]
  }, {
    "p": [138, 32, -119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [138, 32, -85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [-10, 47, -41],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.19, 3.14]
  }, {
    "p": [10, 47, -17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.06, 0]
  }, {
    "p": [261, 32, 80],
    "s": [9, 14, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [271, 32, 80],
    "s": [12, 3, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [271, 44, 80],
    "s": [11, 3, 4],
    "c": "#7a6a5d",
    "t": 11
  }, {
    "p": [275, 35, 78],
    "s": [3, 10, 1],
    "pe": 1,
    "c": "#b4b4b4",
    "t": 2
  }, {
    "p": [272, 34, 78],
    "s": [3, 12, 1],
    "pe": 1,
    "c": "#898989",
    "t": 2
  }, {
    "p": [269, 35, 78],
    "s": [3, 10, 1],
    "pe": 1,
    "c": "#cacaca",
    "t": 2
  }, {
    "p": [266, 35, 78],
    "s": [3, 11, 1],
    "pe": 1,
    "c": "#898989",
    "t": 2
  }, {
    "p": [203, 47, 80],
    "s": [11, 1, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 46, -319],
    "s": [5, 1, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 46, -291],
    "s": [5, 2, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-104, 33, -329],
    "s": [7, 2, 4],
    "l": 1,
    "r": [0, 0.36, 0],
    "c": "#9d8672"
  }, {
    "p": [50, 77, -36],
    "s": [8, 1, 101],
    "i": 9,
    "v": 1,
    "b": -0.1
  }, {
    "p": [-52, 77, -25],
    "s": [8, 1, 212],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 2
  }, {
    "p": [-41, 77, 77],
    "s": [34, 1, 8],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 1
  }, {
    "p": [26, 77, 77],
    "s": [24, 1, 8],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 1
  }, {
    "p": [176, 67, -234],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [176, 68, -236],
    "s": [6, 1, 16],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-46, 90, -195],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-46, 109, -195],
    "s": [1, 5, 1],
    "l": 1,
    "r": [-0.44, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-52, 12, -18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.76, -3.14]
  }, {
    "p": [2, 12, -15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.16, 0]
  }, {
    "p": [-217, 32, -25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-149, 32, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.62, 0],
    "c": "#d2b559"
  }, {
    "p": [-110, 50, 146],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-124, 50, 161],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.26, 0]
  }, {
    "p": [195, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.28, 0]
  }, {
    "p": [-225, 47, 132],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-135, 32, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [164, 192, 142],
    "s": [4, 4, 40],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 192, 142],
    "s": [41, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [240, 33, -202],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [267, 33, -101],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [216, 32, -7],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [286, 32, 31],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [269, 32, -53],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [259, 32, 74],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-21, 12, 7],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [8, 13, -15],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.27, 0],
    "c": "#9d8672"
  }, {
    "p": [-157, 32, 66],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-221, 33, 23],
    "s": [6, 2, 4],
    "l": 1,
    "r": [3.14, -1.49, 3.14],
    "c": "#9d8672"
  }, {
    "p": [-136, 48, 138],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 1.14, 0],
    "c": "#9d8672"
  }, {
    "p": [-129, 33, -14],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.04, 0],
    "c": "#9d8672"
  }, {
    "p": [-143, 33, -251],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [-204, 33, -231],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [153, 33, -311],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [124, 33, -203],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.09, 0],
    "c": "#9d8672"
  }, {
    "p": [216, 33, -141],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [150, 33, 21],
    "s": [4, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [22, 48, 85],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.34, 0],
    "c": "#9d8672"
  }, {
    "p": [-36, 48, 57],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.34, 0],
    "c": "#9d8672"
  }, {
    "p": [-54, 48, 85],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#9d8672"
  }, {
    "p": [-40, 48, -21],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [17, 48, 71],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [10, 55, -23],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [10, 55, -25],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [8, 53, -24],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-193, 32, -41],
    "s": [4, 2, 4],
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#9d8672"
  }, {
    "p": [-195, 32, -35],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-133, 32, -20],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-151, 33, -208],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [223, 32, 77],
    "s": [3, 2, 3],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [248, 32, 75],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [-185, 48, 132],
    "s": [3, 1, 3],
    "l": 1,
    "r": [0, 1.14, 0],
    "c": "#9d8672"
  }, {
    "p": [-20, 48, 76],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 1.49, 0],
    "c": "#9d8672"
  }, {
    "p": [44, 47, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [7, 47, -127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.32, 0]
  }, {
    "p": [-202, 142, -278],
    "s": [44, 0, 18],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [7, 104, -129],
    "s": [48, 0, 19],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [243, 98, 130],
    "s": [48, 0, 19],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 3.14],
    "sad": 1
  }]
}